import { useQuery } from "@tanstack/react-query";
import { apiWithoutCamelization } from "../../../api";
import urls from "../../../urls";
import type { StartPageElectricityTax } from "../StartPage.types";

function useStartPageElectricityTax(year: number, projectId?: string) {
  const { data, error, isLoading } = useQuery({
    queryKey: urls.startPage.electricityTax.key(year, projectId),
    queryFn: () => fetchStartPageElectricityTax(year, projectId)
  });

  return { data, error, isLoading };
}

async function fetchStartPageElectricityTax(year: number, projectId?: string) {
  const response = await apiWithoutCamelization.get<StartPageElectricityTax>(
    urls.startPage.electricityTax.url(year, projectId)
  );
  return response.data;
}

export { useStartPageElectricityTax };
